// extracted by mini-css-extract-plugin
export var socialNavHolder = "SocialNav-module--socialNavHolder--9CWWZ";